require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./centre-de-langues-1-1-9-0.json") })
        }
      }, "path---centre-de-langues-1-1-9-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---centre-de-langues-1-1-9-0!./.cache/json/centre-de-langues-1-1-9-0.json
// module id = 363
// module chunks = 231608221292675